import { render, staticRenderFns } from "./ProjectEditPage.vue?vue&type=template&id=7bc3ede7&scoped=true"
import script from "./ProjectEditPage.vue?vue&type=script&lang=js"
export * from "./ProjectEditPage.vue?vue&type=script&lang=js"
import style0 from "./ProjectEditPage.vue?vue&type=style&index=0&id=7bc3ede7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc3ede7",
  null
  
)

export default component.exports